import { getTradeTime, Trade } from '../entities/shared';
import EntityStore from './entity';

const MAX_CLOSED_TRADES = 50;

export default class TradesStore extends EntityStore<Trade> {
  constructor() {
    const sortComparer = (tradeA: Trade, tradeB: Trade) =>
      getTradeTime(tradeB) - getTradeTime(tradeA);

    super({ sortComparer });
  }

  handleTrade(trade: Trade) {
    this.setOne(trade); // Add the new trade

    const trades = this.selectAll(); // Trades sorted by time

    if (trades.length > MAX_CLOSED_TRADES) {
      const tradesToRemove = trades.slice(MAX_CLOSED_TRADES);

      for (const oldTrade of tradesToRemove) {
        this.removeOne(oldTrade.id, { permanent: true });
      }
    }
  }
}
